import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

export interface WarningChipsProps {
  codes: string[];
  max?: number;
}

export const WARNING_LABEL: Record<string, string> = {
  MISSING_ICD: 'ICD',
  MISSING_NDC: 'NDC',
  MISSING_DOB: 'DOB',
  MISSING_INSURANCE: 'Ins',
  MISSING_CPT: 'CPT',
  MISSING_POS: 'POS',
  UNRECOGNIZED_CARRIER: 'Carrier',
};

function condense(code: string): string {
  return WARNING_LABEL[code] ?? code;
}

const WarningChips: React.FC<WarningChipsProps> = ({ codes, max = 3 }) => {
  if (codes.length === 0) {
    return null;
  }

  const visible = codes.slice(0, max);
  const overflow = codes.slice(max);

  return (
    <Box sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
      {visible.map((code, idx) => (
        <Tooltip key={`${code}-${idx}`} title={code}>
          <Chip
            label={condense(code)}
            size="small"
            variant="outlined"
            color="warning"
          />
        </Tooltip>
      ))}
      {overflow.length > 0 && (
        <Tooltip title={overflow.join(', ')}>
          <Chip
            label={`+${overflow.length}`}
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default WarningChips;
